import { urlBuilder } from '@starjack/utils';
import { BackendType } from '@starjack/utils';
import { baseApi } from '@starjack/api';
import { Billing, convertBillingToFrontend } from '../model/billing.types';

const billingUrls = {
    billing: urlBuilder('order', 'billing'),
};

export const billingApi = baseApi
    .enhanceEndpoints({ addTagTypes: ['BILLINGS'] })
    .injectEndpoints({
        endpoints: (builder) => ({
            getBillings: builder.query<Billing[], { liftOperatorId: string }>({
                query: () => billingUrls.billing,
                transformResponse: (apiReturn: {
                    billingRuns: Billing<BackendType>[];
                }) => apiReturn.billingRuns.map(convertBillingToFrontend),
                providesTags: ['BILLINGS'],
            }),

            postRelease: builder.mutation<Billing, { billingId: string }>({
                query: ({ billingId }) => ({
                    url: `${billingUrls.billing}/${billingId}/release`,
                    method: 'POST',
                    body: undefined,
                }),
                invalidatesTags: ['BILLINGS'],
            }),
        }),
    });

export const { useGetBillingsQuery, usePostReleaseMutation } = billingApi;
